import { UploadFile } from 'antd';
import dayjs from 'dayjs';

import { AutoDeletionAfterEnum } from 'features/Planner';

export enum EditPostPageState {
	POST_EDITOR = 'postEditor',
	PUBLISHING_SETTINGS = 'publishingSettings',
}

export interface IPostFormState {
	channel_ids: string | null;
	date: dayjs.Dayjs | null;
	time: dayjs.Dayjs | null;
	auto_deletion_after: AutoDeletionAfterEnum;
	content?: string | null;
	publishNow: boolean;
	images: UploadFile[] | null;
	published_at?: string;
}
